import esES from '../../.octopus/es-ES/index.js';

export default {
  TntdNewReference: esES,
};
